import { render, staticRenderFns } from "./StudentItem.vue?vue&type=template&id=6ff06861&scoped=true&"
import script from "./StudentItem.vue?vue&type=script&lang=js&"
export * from "./StudentItem.vue?vue&type=script&lang=js&"
import style0 from "./StudentItem.vue?vue&type=style&index=0&id=6ff06861&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff06861",
  null
  
)

export default component.exports